import useSWR from 'swr'
import { LightGroup } from 'domain/models/Group/EntityGroup'
import { apiClient } from 'services/api/client'

export const useGetGroupBySlug = ({ slug }: { slug?: string }) => {
  const key = slug ? `/groups/${slug}` : null
  const fetcher = () =>
    apiClient.get<LightGroup | null>(`/groups/${slug}`).then((res) =>
      res.data
        ? {
            ...res.data,
            registrationClosingDate: res.data.registrationClosingDate
              ? new Date(res.data.registrationClosingDate)
              : null,
            registrationOpeningDate: res.data.registrationOpeningDate
              ? new Date(res.data.registrationOpeningDate)
              : null
          }
        : null
    )
  return useSWR(key, fetcher)
}
